import {
  ArticleIcon,
  CalculatorIcon,
  ChartBarHorizontalIcon,
  ChartBarIcon,
  ChartPieSliceIcon,
  CirclesThreeIcon,
  CoinIcon,
  CompassIcon,
  CurrencyDollarIcon,
  FileTextIcon,
  GridFourIcon,
  Icon,
  InvoiceIcon,
  LegoIcon,
  PresentationChartIcon,
  UsersThreeIcon
} from "@phosphor-icons/react";

export enum EChapterIcon {
  LEGO = "LEGO",
  PRESENTATION_CHART = "PRESENTATION_CHART",
  CIRCLES_THREE = "CIRCLES_THREE",
  CHART_BAR_HORIZONTAL = "CHART_BAR_HORIZONTAL",
  GRID_FOUR = "GRID_FOUR",
  INVOICE = "INVOICE",
  COMPASS = "COMPASS",
  CHART_BAR = "CHART_BAR",
  CHART_PIE_SLICE = "CHART_PIE_SLICE",
  USERS_THREE = "USERS_THREE",
  CURRENCY_DOLLAR = "CURRENCY_DOLLAR",
  CALCULATOR = "CALCULATOR",
  FILE_TEXT = "FILE_TEXT",
  ARTICLE = "ARTICLE",
  COIN = "COIN"
}

export const defaultChapterIcon = EChapterIcon.CHART_BAR;

export const chapterIcons: Record<EChapterIcon, Icon> = {
  [EChapterIcon.LEGO]: LegoIcon,
  [EChapterIcon.PRESENTATION_CHART]: PresentationChartIcon,
  [EChapterIcon.CIRCLES_THREE]: CirclesThreeIcon,
  [EChapterIcon.CHART_BAR_HORIZONTAL]: ChartBarHorizontalIcon,
  [EChapterIcon.GRID_FOUR]: GridFourIcon,
  [EChapterIcon.INVOICE]: InvoiceIcon,
  [EChapterIcon.COMPASS]: CompassIcon,
  [EChapterIcon.CHART_BAR]: ChartBarIcon,
  [EChapterIcon.CHART_PIE_SLICE]: ChartPieSliceIcon,
  [EChapterIcon.USERS_THREE]: UsersThreeIcon,
  [EChapterIcon.CURRENCY_DOLLAR]: CurrencyDollarIcon,
  [EChapterIcon.CALCULATOR]: CalculatorIcon,
  [EChapterIcon.FILE_TEXT]: FileTextIcon,
  [EChapterIcon.ARTICLE]: ArticleIcon,
  [EChapterIcon.COIN]: CoinIcon
};
